import React, { useEffect, useState } from 'react'
import { Typography } from '@material-ui/core';
import moment from 'moment';

import TableCustom from '../../../../../../Components/Table';

import { useStyles } from '../styles';

export default function FichaDadosIniciais({ dadosEspelho }) {

    const classes = useStyles();
    const [data, setData] = useState([]);

    useEffect(() => {
        setData([{
            dataTransmissao: dadosEspelho.dataTransmissao,
            ...dadosEspelho.dadosSegurado
        }]);
    }, [dadosEspelho])

    const columns = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            align: "left",
            width: 40,
            headerRender: (title) => <div style={{ paddingLeft: 12, display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13, paddingLeft: 15 }}>{value}</p>,
        },
        {
            title: "Data de Nascimento",
            dataIndex: "dataNascimento",
            key: "dataNascimento",
            align: "left",
            maxWidth: '15%',
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value !== '-' ? moment(value).format('DD/MM/YYYY') : '-'}</p>,
        },
        {
            title: "Data de Transmissão",
            dataIndex: "dataTransmissao",
            key: "dataTransmissao",
            align: "left",
            maxWidth: '15%',
            headerRender: (title) => <div style={{ display: 'flex' }}>
                <Typography style={{ fontSize: 12, paddingTop: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: (value, row) => <p style={{ fontSize: 13 }}>{moment(value).format('DD/MM/YYYY')}</p>,
        },
        {
            title: "Dados Bancários do Titular para Crédito",
            dataIndex: "contaBancaria",
            key: "contaBancaria",
            align: "left",
            headerRender: (title) => <div style={{ display: 'flex', flexDirection: 'column', borderRight: '1px solid lightgray', borderLeft: '1px solid lightgray', marginRight: 8 }}>
                <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <Typography style={{ fontSize: 12, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{title}</Typography>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 2 }}>
                    <div style={{ width: '30%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{'Tipo de conta'}</Typography>
                    </div>
                    <div style={{ width: '20%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{'Banco'}</Typography>
                    </div>

                    <div style={{ width: '20%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{'Agência'}</Typography>
                    </div>
                    <div style={{ width: '20%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{'Nº da Conta'}</Typography>
                    </div>
                    <div style={{ width: '10%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{'DV'}</Typography>
                    </div>
                </div>
            </div>,
            render: (value, row) =>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 2 }}>
                    <div style={{ width: '30%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 4, fontWeight: 700 }}>{value.tipoConta || '-'}</Typography>
                    </div>
                    <div style={{ width: '20%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 4, fontWeight: 700 }}>{value.numeroBanco || '-'}</Typography>
                    </div>

                    <div style={{ width: '20%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 4, fontWeight: 700 }}>{value.numeroAgencia || '-'}</Typography>
                    </div>
                    <div style={{ width: '20%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 4, fontWeight: 700 }}>{value.numeroConta || '-'}</Typography>
                    </div>
                    <div style={{ width: '10%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Typography style={{ fontSize: 11, paddingTop: 3, paddingRight: 4, fontWeight: 700 }}>{value.digitoVerificador || '-'}</Typography>
                    </div>
                </div>,
        },
        {
            title: "",
            dataIndex: "",
            key: "null",
            width: 80,
            render: (value, row) => <p style={{ fontSize: 13 }}>{''}</p>,
        },
    ];

    const propsTable = {
        columns,
        data,
        heightBody: "auto",
        minHeightBody: "auto",
        marginBorder: false,
        usarMarginBottomContainer: true,
        width: '98%',
        hideBorderBottom: true,
        ativarHoverLinha: false,
        elevationPaper: 0,
        optionsToolbar: {
            info: (
                <div className={classes.header}>
                    <div className={classes.col1}>
                        <div>
                            <Typography className={classes.headerTitle}>{'Ficha Dados Iniciais'}</Typography>
                        </div>
                    </div>
                </div>
            ),
        },
    };

    return (
        <>
            <TableCustom {...propsTable} />
        </>
    )
}
